import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs } from 'react-router';

import type { MaterializedMenuProduct } from '@jane/shared/types';

import { ensureNumericId } from '../../../util';
import { getMaterializedMenuProductQueryBody } from '../queries/product';
import type { InternalFeeling } from '../queries/reviews';
import { getProductFeelingsQueryBody } from '../queries/reviews';

export type ProductDetailLoaderType = {
  product: MaterializedMenuProduct;
  productFeelings: InternalFeeling[];
  productId: number;
};

export const productDetailLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs): Promise<ProductDetailLoaderType> => {
    const { productId, storeId } = params;

    const numericStoreId = ensureNumericId(storeId);
    const numericProductId = ensureNumericId(productId);

    const product = await queryClient.ensureQueryData(
      getMaterializedMenuProductQueryBody(numericProductId, numericStoreId)
    );

    const productFeelings = await queryClient.ensureQueryData(
      getProductFeelingsQueryBody(numericProductId)
    );

    if (!product) {
      throw new Error(
        '[productDetailLoader]: No product returned - it is likely out of stock or hidden by the store.'
      );
    }

    return {
      product,
      productFeelings,
      productId: numericProductId,
    };
  };
